<template>
  <div>
    <h3 class="mb-3">Уменьшения уровня</h3>

    <player-level-decrements-table
      v-if="isLevelDecrementsVisible"
      :levelDecrements="levelDecrements"
    />

    <p v-if="message !== null">
      {{ message }}
    </p>

    <loading-indicator v-if="isLoading"/>
  </div>
</template>

<script>
import { HTTP } from '../../http-common.js';
import notifier from '../../notifier.js';

import LoadingIndicator from '../LoadingIndicator.vue';
import PlayerLevelDecrementsTable from './PlayerLevelDecrementsTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerLevelDecrements',

  components: {
    LoadingIndicator,
    PlayerLevelDecrementsTable,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,

      /** @type {Object[] | null} */
      levelDecrements: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      const decrs = this.levelDecrements;
      if(decrs !== null && decrs.length === 0) {
        return 'Нет событий.';
      }

      return null;
    },

    /** @returns {boolean} */
    isLevelDecrementsVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const decrs = this.levelDecrements;
      return (decrs !== null) && (decrs.length > 0);
    },
  },

  created() {
    this.loadLevelDecrements();
  },

  methods: {
    loadLevelDecrements() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = '/player/' + this.playerId + '/level_decrements';

      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        this.levelDecrements = data;
        //this.levelDecrements = getTestLevelDecrements();

        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};

/*
function getTestLevelDecrements() {
  const decrements = [
    {
      "playerId": 105,
      "id": 2,
      "ctime": 1739816091,
      "oldLevel": 4524,
      "newLevel": 4089
    },
    {
      "playerId": 105,
      "id": 1,
      "ctime": 1739416656,
      "oldLevel": 4514,
      "newLevel": 4080
    },
  ];

  return decrements;
}
*/
</script>
